import { CommonModule } from "@angular/common"
import { Component, inject } from "@angular/core"
import { RouterOutlet } from "@angular/router"
import { AuthService } from "./services/auth.service"

@Component({
	selector: "app-root",
	standalone: true,
	imports: [CommonModule, RouterOutlet],
	templateUrl: "./app.component.html"
})
export class AppComponent {
	private readonly auth = inject(AuthService)

	constructor() {
		this.auth.handleAuthCallback()
	}
}
